import { Component, OnInit } from '@angular/core';
import { ConsigneeService } from 'src/app/services/consignees/consignee.service';
import { ApiResponse } from 'src/app/models/IApiResponse';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-consignees-list',
  templateUrl: './consignees-list.component.html',
  styleUrls: ['./consignees-list.component.css']
})
export class ConsigneesListComponent implements OnInit{
  page: number = 1;
  count: number = 0;
  searchText: string = '';
  consignees: any[] = [];
  public errorMessage: string | null = null;
  public successMessage: string | null = null;
  public isProcessing: boolean = false;

  constructor(
    private consigneeService:ConsigneeService,
  ){}

  ngOnInit(): void {
    this.fetchConsignees();
  }

  fetchConsignees():void{
    this.consigneeService.getAllConsignees().subscribe((response: ApiResponse) =>this.consignees = response.data);
  }

  pageChangeEvent(event: number){
    this.page = event;
    this.fetchConsignees();
  }

  onSearchTextChange(event: Event) {
    this.searchText = (event.target as HTMLInputElement).value;
  }

  deleteConsignee(event: Event,consigneeId:string): void{
    event.preventDefault();
    this.confirmBox(consigneeId);
  }

  confirmBox(consigneeId: string){
      Swal.fire({
        title: 'Confirm Delete',
        text: 'Are you sure you want to delete this consignee? The action is irreversible!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes!',
        cancelButtonText: 'No'
      }).then((result) => {
        if (result.value) {
          this.isProcessing=true;

          this.consigneeService.delete(consigneeId)
          .subscribe({
            next: (response) => {
              if(response.status==='success'){
                this.isProcessing=false;
                this.successMessage=response.message;
                this.errorMessage=''; //Clear error message incase it's available

                //Reload consignees
                this.fetchConsignees();
              }else if(response.status==='error'){
                this.isProcessing=false;
                this.errorMessage=response.message;
              }else{
                this.isProcessing=false;
                this.errorMessage=response.message;
              }
            },
            error: (error) => {
              this.isProcessing=false;
              this.errorMessage=error;
            }
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {

        }
      })
    }
}
